import React, { useEffect } from "react";
import LandingHero from "./sections/LandingHero";
import WorkflowSection from "./sections/WorkflowSection";
import Footer from "./Footer";
import "./styles/website.css";
import Lenis from "@studio-freight/lenis";
import "./styles/ContactPage.css";
import FeaturesSection from "./sections/FeaturesSection";
import ContactSection from "./ContactSection";

const LandingPage = () => {
  useEffect(() => {
    // Smooth Scrolling
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      smoothTouch: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="website-main-wrapper">
      <LandingHero />
      <FeaturesSection />
      <WorkflowSection />

      <div className="con-page-wrapper">
        <ContactSection />
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
